import * as actionTypes from "../_constants/url.constant";
export function saveRedireectUrl(url) {
  return {
    type: actionTypes.DISPATCH_URL,
    payload: url
  };
}
